import React from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload, UploadFile } from "antd";
import { UploadChangeParam } from "antd/es/upload";
import { RcFile } from "antd/lib/upload";
import { FileData } from "../../types/Aba";

export type AbaFileLoaderProps = {
  onUpload: (file: FileData) => void;
  onError: () => void;
  loading: boolean;
};

const AbaFileLoader: React.FC<AbaFileLoaderProps> = ({
  onUpload,
  onError,
  loading,
}: AbaFileLoaderProps) => {
  const onFileUpload = (info: UploadChangeParam<UploadFile<any>>) => {
    const reader = new FileReader();
    const fileBlob = info.file as RcFile;
    reader.readAsText(fileBlob, "UTF-8");
    reader.onload = async (evt) => {
      onUpload({
        name: info.file.name,
        contents: evt.target?.result as string,
      });
    };
    reader.onerror = () => {
      onError();
    };
  };

  return (
    <div className="aba-file-upload">
      <Upload
        onChange={onFileUpload}
        disabled={loading}
        showUploadList={false}
        beforeUpload={() => false}
        data-testid="aba-file-uploader"
      >
        <Button
          icon={<UploadOutlined />}
          loading={loading}
          disabled={loading}
          className="upload-btn"
          data-testid="file-upload-btn"
        >
          Click to Upload
        </Button>
      </Upload>
    </div>
  );
};

export default AbaFileLoader;
